import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";
import TemplateForm from "@/components/document-templates/template-form";

export const Route = createFileRoute(
  "/_authenticated/documents/templates/new",
)({
  component: NewTemplatePage,
});

function NewTemplatePage() {
  const navigate = useNavigate();

  return (
    <RouteGuardPermissions
      permissions={[{ module: "document_templates", actions: ["create"] }]}
    >
      <TemplateForm
        onCancel={() => navigate({ to: "/documents" })}
        onSuccess={() => navigate({ to: "/documents" })}
      />
    </RouteGuardPermissions>
  );
}
